import type { NavigationGuard } from 'vue-router'
import { features } from '@/config/brands'
import { useUserStore } from '@/stores'
import { $getDeviceId, $getToken } from '@/helpers'
import { i18n } from '@/i18n'
import { ERROR_PAGE_LEVEL } from '@/constants'

// 在游客登录、token 回跳等基础守卫完成之后执行，页面挂载之前拦截。
export const accountPageLoginGuard: NavigationGuard = async (to, _from, next) => {
  if (!features?.requireLoginForAccountPages || !['history', 'member'].includes(to.name || ''))
    return next()

  const user = useUserStore()
  const redirect = new URL(to.fullPath, window.location.origin).href
  try {
    await user.init()
    // 游客 token 不代表正式登录，与加入书架的判断保持一致。
    if (user.$state.thirdPartType || user.$state.email)
      return next()

    return next({
      name: 'login',
      query: {
        from: to.name === 'history' ? 'Library' : 'Profile',
        redirect,
        lang: i18n.locale,
        d: $getDeviceId(),
        t: $getToken(),
      },
    })
  }
  catch (error: any) {
    return next({
      name: 'error',
      query: { level: ERROR_PAGE_LEVEL.DEFAULT, message: error?.msg || error?.message, redirect: encodeURIComponent(redirect) },
      replace: true,
    })
  }
}
